import React from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import { useParams, useLocation } from 'react-router-dom'
import Loader from 'shared/components/Loader'
import Layout from 'components/PrivateRoutes/Layout'
import ProductDelivery from './ProductDelivery'
import DeliverySidebar from './DeliverySidebar'
import SupplementalProducts from './SupplementalProducts'
import { Booking } from './types'
import AssetDeliveryProvider, { productFragment } from './AssetDeliveryContext'
import './index.scss'

interface DeliverQuery {
  booking: Booking
}

export const deliveryQuery = gql`
  query DeliveryQuery($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      isOpenDroneCategory
      estate {
        id
        streetAddress
      }
      products {
        edges {
          node {
            id
            name
            state
            ... on PhotoBasedProduct {
              availableCommentsForEditing
              quantity
              availablePhotoLabels {
                name
                systemName
              }
            }
            ... on VideoProduct {
              drone
            }
            ...Product
          }
        }
      }
      availableProductsToSupplement
    }
  }
  ${productFragment}
`

function Content({ data }: { data: DeliverQuery }) {
  const booking = data.booking
  const products = booking.products.edges.map(e => e.node)
  const deliverableProducts = products.filter(p => p.__typename !== 'DigitalPlanDrawingProduct')

  return (
    <>
      <AssetDeliveryProvider>
        <h2>{booking.estate.streetAddress}</h2>
        <div className="booking-delivery">
          <div className="delivery-products">
            {deliverableProducts.map((product) => (
              <ProductDelivery
                key={product.id}
                product={product}
              />
            ))}
          </div>

          <div>
            <DeliverySidebar booking={booking} products={deliverableProducts} />
            <SupplementalProducts
              bookingId={booking.id}
              availableProductsToSupplement={booking.availableProductsToSupplement}
            />
          </div>
        </div>
      </AssetDeliveryProvider>
    </>
  )
}

function Delivery() {
  const location = useLocation()
  const params = useParams<{id: string}>()

  const {data, loading, error} = useQuery<DeliverQuery>(deliveryQuery, {
    variables: {bookingId: params.id}
  })

  return (
    <Layout
      location={location}
      title="Leveranse"
      defaultBackTo="/bookings"
    >
      <Loader loading={loading} error={error}>
        {!!data && <Content data={data} />}
      </Loader>
    </Layout>
  )
}

export default Delivery
